import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { getFullUser, setActionTaken } from '../services';
import ExperienceBanner from './banners/experience/experience_banner';
import CitizenshipsLanguagesBanners from './banners/citizenships_languages/citizenships_languages';
import CountryBanner from './banners/country/country_banner';
import EmploymentLocationBanner from './banners/employment_location/employment_location';

const DataGatheringBanner = ({ requestedField }) => {
  if (!requestedField) return;

  const [user, setUser] = useState(null);
  const [visible, setVisible] = useState(false);

  /**
   * When the component did mount, call the services `userFullDetail`
   * which is in charge of getting the user data, if the request is successful
   * set the user data to the variable `user` and the variable `visible` to `true`.
   */
  useEffect(() => {
    getFullUser()
      .then((response) => response.json())
      .then((data) => {
        setUser(data);
        setVisible(true);
      });
  }, []);

  /**
   * If the user clicks in the X symbol at the right top of the banner, sends to the
   * BE the action taken with the services `setActionTaken` and close the banner.
   *
   * @returns {undefined}
   */
  const closeBanner = () => {
    setActionTaken(requestedField, 'closed');
    setVisible(false);
  };

  /**
   * Based on the requested field, it returns the appropriate
   * Banner component and pass the user information to it.
   *
   * @param {object} userData - User data
   *
   * @returns {JSX} - Banner component
   */
  const displayBanner = (userData) => {
    switch(requestedField) {
      case 'experience_duration':
        return (
          <ExperienceBanner
            userID={userData.id}
            years={userData.experience_duration}
            setVisible={setVisible} />
        );
      case 'citizenships':
        return (
          <CitizenshipsLanguagesBanners
            type='citizenships'
            userID={userData.id}
            values={userData.citizenships}
            setVisible={setVisible} />
        );
      case 'languages':
        return (
          <CitizenshipsLanguagesBanners
            type='languages'
            userID={userData.id}
            values={userData.languages}
            setVisible={setVisible} />
        );
      case 'country':
        return (
          <CountryBanner
            userID={userData.id}
            value={userData.country}
            setVisible={setVisible}
          />
        );
      case 'employment_location':
        return (
          <EmploymentLocationBanner
            employments={userData.employments}
            setVisible={setVisible}/>
        );
      // No default
    }
  };

  return (
    <div className={`data-gathering-wrapper ${visible && 'visible'}`}>
      <div className='data-gathering-widget z-depth-2'>
        <div className='text-right'>
          <button type='button' className='btn-link btn text-gray-lig' onClick={closeBanner}>
            <i className='fal icon-times'></i>
          </button>
        </div>
        {user && displayBanner(user)}
      </div>
    </div>
  );
};

DataGatheringBanner.propTypes = {
  requestedField: PropTypes.string.isRequired,
};

export default DataGatheringBanner;
